import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'; 

const MyTooltip = (props) => {
  return (
    <Tooltip
      id={props.id}
      place='bottom'
      effect="solid"
      event="click"
      multiline={true}
      data-html={true}
      style={{ maxWidth: '399px', backgroundColor: '#00467f', color: 'white' }}
    >
      {props.children}
    </Tooltip>
  );
};

export default withTranslation()(MyTooltip);